import { Alert, Button, Card, CardContent, CardHeader, Stack, Typography } from '@mui/material'
import { useOperationsStore } from '@operations/AppProvider'
import { useTranslate } from '@tolgee/react'
import { DashboardTile, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { EquipmentsPlanned } from './equipment.model'

interface Props {
  onViewClick: () => void
  isForRailVisit?: boolean
}

export const EquipmentPlanningSummary = observer(({ onViewClick, isForRailVisit }: Props) => {
  const {
    equipmentsVesselVisitUIStore,
    tenantConfigStore,
    hasVisitWorkInstructionAndWorkQueueUIStore,
  } = useOperationsStore()

  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  if (tenantConfigStore.skipCraneSplit) return <></>

  const getContent = (label: string, equipmentsPlanned: EquipmentsPlanned[]) => {
    const equipments = equipmentsPlanned.map(eq => `${eq.type} (${eq.equipmentCount})`)

    return <DashboardTile label={label} value={equipments.length ? equipments.join(', ') : 0} />
  }

  return (
    <Card sx={{ width: '100%', height: '100%' }}>
      <CardHeader
        action={
          <Button
            color='inherit'
            onClick={onViewClick}
            data-cy='plan-equipment-btn'
            disabled={!hasVisitWorkInstructionAndWorkQueueUIStore.hasWorkQueue && !isForRailVisit}
          >
            {t('plan', 'Plan')}
          </Button>
        }
        title={<Typography variant='h2'>{t('equipment', 'Equipment')}</Typography>}
      />
      <CardContent sx={{ minHeight: '100%' }}>
        <Stack gap={1}>
          <Stack direction='row' gap={theme.customSpacing.xxl}>
            {getContent(
              t('discharge', 'Discharge'),
              equipmentsVesselVisitUIStore.dischargeEquipments,
            )}

            {getContent(t('load', 'Load'), equipmentsVesselVisitUIStore.loadEquipments)}
          </Stack>
          {!isForRailVisit && !hasVisitWorkInstructionAndWorkQueueUIStore.hasWorkInstruction && (
            <Alert severity='warning'>
              {t(
                'equipmentPlanningNotPossiblePleaseAddOrders',
                'Equipment planning not currently possible. Please add the orders.',
              )}
            </Alert>
          )}
          {!isForRailVisit &&
            hasVisitWorkInstructionAndWorkQueueUIStore.hasWorkInstruction &&
            !hasVisitWorkInstructionAndWorkQueueUIStore.hasWorkQueue && (
              <Alert severity='warning'>
                {t(
                  'equipmentPlanningNotPossiblePleaseCreateCraneSplit',
                  'Equipment planning not currently possible. Please create the crane split.',
                )}
              </Alert>
            )}
        </Stack>
      </CardContent>
    </Card>
  )
})
